import { render, staticRenderFns } from "./DeilveryHis.vue?vue&type=template&id=3219a81f"
import script from "./DeilveryHis.vue?vue&type=script&lang=js"
export * from "./DeilveryHis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports